import React from 'react';
import Slider from 'react-slick';
import CustomScrollTrigger from 'js/wrapper/CustomScrollTrigger';
import { Parallax } from 'react-scroll-parallax';
import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import { Col } from 'react-bootstrap';

import { useAbstractCmsElement } from 'components/cms/hooks/useAbstractCmsElementNew';

import ItemGridViewWireframe from 'components/layout/wireframes/SummaryItemGridView';

function CmsElementCommerceProducts(props) {
  const {
    editMode,
    index,
    showElementSettings,
    layout, // Wird für die Breakpoint-Logik der Dots benötigt
  } = props;

  // CMS Logic Hook
  const {
    shown,
    setShown,
    getMainId,
    getCustomId,
    getParamValue,
    getBackgroundStyle,
    elementStyleTag,
    getParallaxData,
    getAppendHtml,
    cssClasses,
    responsiveClasses,
  } = useAbstractCmsElement(props);

  // dnd-kit Sortable Hook
  const { attributes, listeners, setNodeRef, transform, transition, isDragging } = useSortable({
    id: index,
    disabled: !editMode,
  });

  // Drag & Drop Styles
  const dndStyle = {
    transform: CSS.Translate.toString(transform),
    transition,
    opacity: isDragging ? 0.5 : 1,
    zIndex: isDragging ? 1000 : 'auto',
    position: 'relative',
    width: '100%',
    cursor: editMode ? 'move' : 'default',
  };

  // Slider Settings
  const layoutVersion = getParamValue('layoutVersion', 'slider');
  const sliderSettings = {
    dots: layout?.breakpointIndex > 1,
    infinite: false,
    speed: 500,
    slidesToShow: 4,
    slidesToScroll: 4,
    initialSlide: 0,
    responsive: [
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
          infinite: true,
          dots: true,
        },
      },
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
          initialSlide: 2,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };

  // Mock-Daten für die Wireframes (identisch zum Original)
  const mapping = Array.from({ length: 16 }, (_, i) => i);

  // Visual Logic
  const isVisible = editMode || shown;
  const shownClass = isVisible ? 'elem-shown' : 'elem-hidden';
  const mainColorClass = `text-${getParamValue('mainColor', 'master')}`;

  const parallaxData = getParallaxData();

  const innerContent = (
    <div
      id={getMainId()}
      className={`ms-ecommerce-products-content ${mainColorClass} ${shownClass} ${responsiveClasses} ${cssClasses}`.trim()}
      onClick={(e) => editMode && showElementSettings(e, index)}
      style={getBackgroundStyle()}
    >
      {elementStyleTag}

      {layoutVersion === 'slider' && (
        <Slider {...sliderSettings}>
          {mapping.map((i) => (
            <div className="padding-15" key={i}>
              <ItemGridViewWireframe />
            </div>
          ))}
        </Slider>
      )}

      {layoutVersion === 'list' && (
        <div className="clearfix">
          {mapping.map((i) => (
            <Col lg={4} md={6} xs={12} key={i}>
              <ItemGridViewWireframe />
            </Col>
          ))}
        </div>
      )}

      {getAppendHtml()}
    </div>
  );

  return (
    <div ref={setNodeRef} style={dndStyle} {...attributes} {...listeners}>
      <div>
        <CustomScrollTrigger className="cms-overflow-fix" onEnter={() => setShown(true)} {...getCustomId()}>
          {parallaxData ? (
            <Parallax {...parallaxData}>
              {innerContent}
            </Parallax>
          ) : (
            innerContent
          )}
        </CustomScrollTrigger>
      </div>
    </div>
  );
}

export default CmsElementCommerceProducts;
